import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../App.css';
import apiService from '../../API/ApiService';
import Filter from '../Filter/Filter';
import DualSenseTable from '../DualSenseTable/DualSenseTable';
import { useLocation } from 'react-router-dom';
import DeviceDetailsModal from '../DeviceDetailsModal/DeviceDetailsModal';
const SearchResult = () => {
  const [dualSenseData, setDualSenseData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [selectedDualSense, setSelectedDualSense] = useState(null);
  const [modalShow, setModalShow] = useState(false);
  const [devices, setDevices] = useState([]);
  const [raspberries, setRaspberries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [appliedFilters, setAppliedFilters] = useState({
    device: null,
    raspberry: null,
    status: null,
    dateRange: null,
    timeRange: { start: null, end: null },
  });

  const location = useLocation();
  const { username: usernameFromLocation } = location.state || {};
  const username = usernameFromLocation || localStorage.getItem('trimmedUsername');
  const isInitialMount = useRef(true);

  const trimmedUsername = username?.trim() || '';
  localStorage.setItem('trimmedUsername', trimmedUsername);

  const hasFiltersApplied = () => {
    return (
      appliedFilters.device !== null ||
      appliedFilters.raspberry !== null ||
      appliedFilters.status !== null ||
      (appliedFilters.dateRange !== null && appliedFilters.dateRange.some(date => date !== null)) ||
      (appliedFilters.timeRange.start !== null || appliedFilters.timeRange.end !== null)
    );
  };

  const fetchData = async (filters = {}) => {
    setLoading(true);
    setError(null);

    try {
      let apiEndpoint = '/';
      if (trimmedUsername === "GL_EU") {
        apiEndpoint = '/?username=GL_EU';
      } else if (trimmedUsername === "GL_US") {
        apiEndpoint = '/?username=GL_US';
      }
      else if (trimmedUsername === "SONY_DS5") {
        apiEndpoint = '/?username=SONY_DS5'; 
      }
       else if (trimmedUsername === "NWT_DS5") {
        apiEndpoint = '/?username=NWT_DS5'; 
      }
      const params = {
        ...filters,
        date: filters.dateRange || filters.date,
        timeStart: filters.timeRange?.start || filters.timeStart,
        timeEnd: filters.timeRange?.end || filters.timeEnd,
        status: filters.status || null
      };
      console.log("apiEndpoint is ",apiEndpoint)
      const response = await apiService.get(apiEndpoint, { params });
      console.log("fetchData is ",response.data)
      setDualSenseData(response.data.data);
      setFilteredData(response.data.data);
      setTotalCount(response.data.totalCount);
    } catch (error) {
      console.error('Fetch error:', error);
      setError('Error fetching data. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const fetchRaspberries = async () => {
    try {
      let apiEndpoint = '/getIdFromRaspberries';
      if (trimmedUsername === "GL_EU") {
        apiEndpoint = '/getIdFromRaspberries/?username=GL_EU';
      } else if (trimmedUsername === "GL_US") {
        apiEndpoint = '/getIdFromRaspberries/?username=GL_US';
      }
      else if (trimmedUsername === "SONY_DS5") {
        apiEndpoint = '/getIdFromRaspberries/?username=SONY'; 
      }
      else if (trimmedUsername === "NWT_DS5") {
        apiEndpoint = '/getIdFromRaspberries/?username=NWT'; 
      }
      const response = await apiService.get(apiEndpoint);
      console.log("fetchRaspberries is ",response.data)
      setRaspberries(response.data.raspberries || []);
    } catch (error) {
      console.error('Fetch raspberries error:', error);
      setError('Error fetching testers list.');
    }
  };

  useEffect(() => {
    if (isInitialMount.current) {
      fetchData();
      fetchRaspberries();
      isInitialMount.current = false;
    }
  }, [trimmedUsername]);

  const handleFilterChange = (filters) => {
    const newFilters = {
      device: filters.device,
      raspberry: filters.raspberry,
      status: filters.status,
      dateRange: filters.date,
      timeRange: {
        start: filters.timeStart,
        end: filters.timeEnd,
      },
    };

    setAppliedFilters(newFilters);
    fetchData(newFilters);
  };

  const handleCloseModal = () => {
    setModalShow(false);
    setSelectedDualSense(null);
  };

  const handleDualSenseClick = (dualSense) => {
    setSelectedDualSense(dualSense);
    setModalShow(true);
  };

  return (
    <div className="container search-result-container">
      {loading && (
        <div className="loading-overlay">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      {error && (
        <div className="alert alert-danger alert-dismissible fade show" role="alert">
          {error}
          <button 
            type="button" 
            className="btn-close" 
            onClick={() => setError(null)}
          />
        </div>
      )}

      <Filter
        devices={devices}
        raspberries={raspberries}
        onFilterChange={handleFilterChange}
      />

      {hasFiltersApplied() && (
        <div className="applied-filters card mb-4">
          <div className="card-body">
            <h5 className="card-title">Applied Filters</h5>
            <div className="d-flex flex-wrap gap-2">
              {appliedFilters.device && (
                <span className="badge bg-primary">
                  Device: {appliedFilters.device}
                </span>
              )}
              
              {appliedFilters.raspberry && (
                <span className="badge bg-primary">
                  Tester: {appliedFilters.raspberry}
                </span>
              )}
              
              {appliedFilters.status && (
                <span className="badge bg-primary">
                  Status: {appliedFilters.status}
                </span>
              )}
              
              {appliedFilters.dateRange?.[0] && appliedFilters.dateRange[1] && (
                <span className="badge bg-primary">
                  Date: {new Date(appliedFilters.dateRange[0]).toLocaleDateString()} - {new Date(appliedFilters.dateRange[1]).toLocaleDateString()}
                </span>
              )}
            </div>
          </div>
        </div>
      )}

      {!loading && !error && (
        <>
          {filteredData.length === 0 ? (
            <div className="alert alert-info">
              No results found for the selected filters
            </div>
          ) : (
            <DualSenseTable
              filteredData={filteredData}
              onDualSenseClick={handleDualSenseClick}
              totalCount={totalCount}
              appliedFilters={appliedFilters}
            />
          )}
        </>
      )}
          <DeviceDetailsModal 
        show={modalShow} 
        onHide={handleCloseModal} 
        dualSense={selectedDualSense} 
      />
    </div>
  );
};

export default SearchResult;
